var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsuptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CONSUPTION_ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #CONSUPTION_ICON .cls-1 {\n        fill: #f5f5f5;\n      }\n\n      #CONSUPTION_ICON .cls-2 {\n        fill: #c5d75d;\n      }\n\n      #CONSUPTION_ICON .cls-3 {\n        fill: none;\n        stroke: #f5f5f5;\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_442",
    "data-name": "Pfad 442",
    className: "cls-1",
    d: "M1193.817,525.68a14,14,0,1,1-14,14,14.016,14.016,0,0,1,14-14m0-2a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z",
    transform: "translate(-1177.817 -523.68)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_488",
    "data-name": "Pfad 488",
    className: "cls-2",
    d: "M1207.65,702.58v.05a6.265,6.265,0,1,1-12.53,0,.435.435,0,0,0,.01-.05h7.44v.02a1.605,1.605,0,1,0,3.21,0v-.02Z",
    transform: "translate(-1185.386 -684.232)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_25",
    "data-name": "Vereinigungsmenge 25",
    className: "cls-3",
    d: "M-13390-4870.552a.357.357,0,0,0,.01-.047h7.44v.02a1.621,1.621,0,0,0,1.6,1.63,1.623,1.623,0,0,0,1.612-1.63v-.02h1.869v.047a6.3,6.3,0,0,1-6.261,6.341A6.308,6.308,0,0,1-13390-4870.552Zm10.662-.047a1.623,1.623,0,0,0-1.612-1.61,1.618,1.618,0,0,0-1.6,1.61h-7.44c.051-3.532,6.261-12.4,6.261-12.4s6.2,8.868,6.261,12.4Z",
    transform: "translate(13399.733 4888.948)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsuptionIcon);
export default __webpack_public_path__ + "static/media/consuption-icon.1249d3f18599989cd115319d31aeb5cc.svg";
export { ForwardRef as ReactComponent };